'use strict';

angular.module('dekky.forms')
    .directive('formErrors', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                var $element = angular.element(element);

                $element.bind('submit', function (e) {
                    e.preventDefault();

                    if (scope[attributes.name].$invalid) {
                        window.scrollTo(0, $element.find('.ng-invalid').first().offset().top - 15);
                        $element.find('.ng-error').removeClass('ng-error');
                        $element.find('.ng-invalid').addClass('ng-error');
                        return false;
                    }
                });
            }
        }
    });
